var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"my-modal",attrs:{"title":"System Message"},on:{"ok":_vm.setVisible}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.getModalMessage))]),(_vm.getModalSubMessage)?_c('small',[_vm._v(_vm._s(_vm.getModalSubMessage))]):_vm._e(),_c('div',{staticStyle:{"height":"10px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }